export default "__VITE_ASSET__DYZkjizB__"